import React, { useContext } from 'react';
import { InteractionSource } from 'utils/analytics/AnalyticsV2Service.generated';

export type InteractionSourceContextType = InteractionSource | '';

export const InteractionSourceContext =
    React.createContext<InteractionSourceContextType>('');

export const useInteractionSourceContext = (): InteractionSourceContextType =>
    useContext(InteractionSourceContext);

export function withInteractionSource<T extends {}>(
    // eslint-disable-next-line @typescript-eslint/naming-convention
    WrappedComponent: React.FC<T>,
    interactionSource: InteractionSource,
): React.FC<T> {
    return function WithInteractionSource(props: T) {
        return (
            <InteractionSourceContext.Provider value={interactionSource}>
                <WrappedComponent {...props} />
            </InteractionSourceContext.Provider>
        );
    };
}
